/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { StripePrice } from "./StripePrice";
import { StripeMetadata } from "./StripeMetadata";
export const Product = core.serialization.object({
    id: core.serialization.string(),
    object: core.serialization.string(),
    active: core.serialization.boolean(),
    attributes: core.serialization.list(core.serialization.string()),
    created: core.serialization.number(),
    defaultPrice: core.serialization.property("default_price", StripePrice),
    description: core.serialization.string(),
    metadata: StripeMetadata,
    name: core.serialization.string(),
});
